import React from 'react';
import { Link } from 'react-router-dom';
import { RoutesCopRattachee } from '../../App_Data/Routes';

const Element = (props) => {
    const Route = RoutesCopRattachee.find(route => route.path.split('/').slice(-1)[0] === props.path);
    if (!Route) return null;

    return props.estActive ? (
        <li className="breadcrumb-item active" aria-current="page">
            {Route.titre}
        </li>
    ) : (
        <li className="breadcrumb-item">
            <Link to={Route.path}>{Route.titre}</Link>
        </li>
    );
};

const BreadCrumb = (props) => {
    if (props.location.pathname === '/') return null;

    const nav = props.location.pathname.slice(1).split('/');
    if (nav.length === 1) return null;

    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                {nav.map((item, i) => <Element key={i} path={item} estActive={i === nav.length - 1} />)}
            </ol>
        </nav>
    );
};

export default BreadCrumb;



// WEBPACK FOOTER //
// ./src/components/App/BreadCrumb.js